<template>
  <div class="page-header header-filter">
    <el-carousel height="100vh">
      <el-carousel-item>
        <div class="page-header header-filter">
          <div class="page-header-image" id="bridge-main-img"></div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div
      class="page-header-image"
      style="background-image: url('img/jipvio-bg1.jpg')"
    ></div>
    <div class="page-header-image"></div>
    <div class="content-center jipvio-searchbar">
      <div class="container">
        <div class="row">
          <div class="col-12 ml-auto mr-auto">
            <div
              class="card card-raised card-form-horizontal card-plain"
              data-background-color
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-5">
                    <img
                      class="jipvio-logo-bg"
                      src="/img/jipvio-logo-text-w.png"
                    />
                    <h4>비대면 부동산 전속중개 플랫폼</h4>
                  </div>
                  <div class="col-lg-7 jipvio-main-search">
                    <el-autocomplete
                      id="srchPageInput"
                      v-model="keyword"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="어디에 살고 싶으신가요? (지역/건물명 입력)"
                      @select="handleSelect"
                    >
                      <i slot="prefix" class="jipvio-ui-icons-search"></i>
                    </el-autocomplete>
                    <!--
                    <fg-input
                      @keyup.enter.native="search"
                      v-model="keyword"
                      type="text"
                      class
                      placeholder="어디에 살고 싶으신가요? (지역/건물명 입력)"
                      addon-left-icon="now-ui-icons ui-1_zoom-bold"
                    ></fg-input>
                    -->
                    <h5 class="jipvio-text-center pt-20">
                      현재 서울 구로구 지역 일부를 대상으로 시범운영 중입니다.
                    </h5>
                    <!-- <h5 class="jipvio-text-left pt-0">
                      * 시범운영 후, 서울 전 지역으로 서비스를 확장할 예정입니다.
                    </h5> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, InfoSection, FormGroupInput } from "@/components";
import { API_KEY } from "@/constants";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

import { Carousel, CarouselItem, Autocomplete } from "element-ui";

import kko from "@/service/kakao";

Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY
  }
});
export default {
  name: "contact-us",
  bodyClass: "" /*sohyun이가 삭제*/,
  components: {
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Autocomplete.name]: Autocomplete
  },
  created() {},

  mounted() {},

  // watch: {
  //   keyword(newValue, oldValue) {
  //     this.getSrchList(newValue);
  //   }
  // },

  data() {
    return {
      keyword: null,

      //searchResult: [],
      timeout: null
    };
  },
  methods: {
    search() {
      this.$router.push({
        path: "/search/result",
        query: { x: this.x, y: this.y }
      });
    },

    async querySearchAsync(queryString, cb) {
      let searchResult = [];
      if (queryString != null && queryString != "") {
        // address 검색
        const kkoRes = await kko.getListByAddr(queryString);
        if (kkoRes.data.documents.length > 0) {
          kkoRes.data.documents.forEach(srl => {
            searchResult.push({
              value: srl.address_name,
              x: srl.x,
              y: srl.y
            });
          });
        } else {
          // keyword 검색
          const kkoResByKwd = await kko.getListByKeyWord(queryString, "");
          kkoResByKwd.data.documents.forEach(srl => {
            searchResult.push({
              value: srl.place_name,
              x: srl.x,
              y: srl.y
            });
          });
        }
      }
      //timeout
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(searchResult);
      }, 300);
    },

    handleSelect(item) {
      console.log(item);
      // ====================================실제 사용할 코드
      // this.$router.push({
      //   path: "/search/result/test",
      //   query: { x: item.x, y: item.y, name: item.value }
      // });

      // ====================================데모에 사용할 코드
      this.$router.push({
        path: "/search/result",
        query: {
          x: 126.858330553006,
          y: 37.5017185630595,
          name: "서울 구로구 고척동 134-112"
        }
      });
    }
  }
};
</script>
<style>
svg#livingroom-light {
  position: absolute;
  top: 5vh;
}
svg#livingroom-main1 {
  position: absolute;
  bottom: -7vh;
}

.main-light {
  transition: all 2s linear;
  animation-name: lightonoff;
  animation-duration: 3s;
  animation-delay: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes lightonoff {
  20% {
    fill: #ffffff;
  }
  60% {
    fill: #ffffff;
  }
  80% {
    fill: #fcda86;
  }
}
.jipvio-main-search h5 {
  letter-spacing: -0.2px;
}
@media screen and (max-width: 991px) {
  svg#livingroom-light {
    top: 5vh;
  }
  svg#livingroom-main1 {
    bottom: -3vh;
  }
  .jipvio-main-search h5 {
    text-align: center !important;
    font-size: 1.2em;
    text-shadow: 1.5px 1.5px 2.5px #797979;
  }
}
@media screen and (max-width: 517px) {
  svg#livingroom-light {
    top: 53vh;
  }
  svg#livingroom-main1 {
    bottom: 13vh;
  }
  .jipvio-main-search h5 {
    font-size: 1.1em;
  }
}
</style>
